import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Sparkles } from "lucide-react";
import { ChatPanel } from "./ChatPanel";
import { isAgentConfigured } from "../hooks/useAgent";
import type { Theme } from "../hooks/useTheme";

type Props = {
  theme: Theme;
};

export function ChatLauncher({ theme }: Props) {
  const { accounts } = useMsal();
  const [open, setOpen] = useState(false);

  if (!isAgentConfigured()) return null;

  const account = accounts[0];
  const userId = account?.localAccountId ?? account?.homeAccountId ?? "user";
  const userName = account?.name ?? account?.username ?? "You";

  return (
    <>
      <button
        type="button"
        className={`chat-launcher${open ? " is-open" : ""}`}
        onClick={() => setOpen((o) => !o)}
        aria-label={open ? "Close AI assistant" : "Open AI assistant"}
        title="Ask AI"
      >
        <Sparkles size={20} />
        <span className="chat-launcher-label">Ask AI</span>
      </button>
      <ChatPanel
        open={open}
        onClose={() => setOpen(false)}
        theme={theme}
        userId={userId}
        userName={userName}
      />
    </>
  );
}
